export const ACTION = {
  TOGGLE_INCLUDE_EXCLUDE_INLINE: 'TOGGLE_INCLUDE_EXCLUDE_INLINE',
  TOGGLE_INCLUDE_EXCLUDE_BULK: 'TOGGLE_INCLUDE_EXCLUDE_BULK',
  TOGGLE_SPEND_RATIO_METHOD: 'TOGGLE_SPEND_RATIO_METHOD',
  REMOVE_MODELLING: 'REMOVE_MODELLING',
  ADD_TO_MODELLING: 'ADD_TO_MODELLING',
}

export type ActionNameType = keyof typeof ACTION
